import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.claim}irsh/translate`;

export interface TranslateIrshCommandArgs {
  issueId?: string;
  reasonId?: string;
  solutionId?: string;
  warrantyTypeId?: string;
}

export interface IrshSummary {
  issueName?: string;
  issueUniqueName?: string;
  reasonName?: string;
  reasonUniqueName?: string;
  solutionName?: string;
  solutionUniqueName?: string;
  warrantyTypeName?: string;
  warrantyTypeUniqueName?: string;
}

export const translateIrshRequest = (
  payload: TranslateIrshCommandArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.POST, json: payload },
});

const translateIrshCommand = async (
  payload: TranslateIrshCommandArgs,
): Promise<BackResponse<IrshSummary> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<IrshSummary>>(
      translateIrshRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default translateIrshCommand;
